import React from 'react';
import {
  AutocompleteInput,
  ReferenceInput,
  ReferenceInputProps,
  required,
} from 'react-admin';
import { useWatch } from 'react-hook-form';

interface AutoCompleteOfficeInputProps
  extends Omit<ReferenceInputProps, 'reference' | 'filterToQuery'> {
  clientId?: string;
  isRequired?: boolean;
}

const AutocompleteOfficeInput: React.FC<AutoCompleteOfficeInputProps> = ({
  source,
  label,
  filter,
  clientId: providedClientId,
  isRequired,
  disabled,
  ...props
}) => {
  const watchedClientId = useWatch({ name: 'clientId' });
  const clientId = providedClientId || watchedClientId;

  if (!clientId) {
    return (
      <AutocompleteInput
        source={source}
        label={label}
        choices={[]}
        disabled={true}
        helperText="Please select a client first"
      />
    );
  }

  return (
    <ReferenceInput
      {...props}
      source={source}
      filter={{ ...filter, clientId: clientId }}
      reference="Office"
      filterToQuery={(name: string) => ({
        name,
      })}
    >
      <AutocompleteInput
        optionText="name"
        filter="name"
        label={label}
        isRequired={isRequired}
        validate={isRequired ? required('Office is required') : undefined}
        noOptionsText="No offices for this client"
        disabled={disabled}
      />
    </ReferenceInput>
  );
};

export default AutocompleteOfficeInput;
